import React from "react";
import cn from "classnames";
import Button from "../controls/Button";
import { FieldInputProps } from "react-final-form";

interface Props {
  className?: string;
  disabled?: boolean;
  i18nKey: string;
  input: FieldInputProps<string | number, HTMLElement>;
  key: string;
  symbolId?: SvgSymbolId;
  value: string;
}

const SelectionButton = ({ className, disabled, i18nKey, input, value, symbolId }: Props) => {
  return (
    <Button
      className={cn("SelectionButton", className, { isSelected: value === input.value })}
      disabled={disabled}
      i18key={i18nKey}
      iconClass="ml-3"
      iconSize="36"
      id={`btn_loan_purpose_${value}`}
      onClick={() => input.onChange(value)}
      rightSymbolId={symbolId}
    />
  );
};

export default SelectionButton;
